import Axios from "axios";

export const getDeliveryTimes= async () => {
  return Axios.get("/api/v1/delivery_times")
    .then((res) => {
      if (!res.data) throw new Error("");
      return res.data;
    })
    .catch((err) => {
      console.log("Error: ", err);
      return [];
    });
};